module.exports = __webpack_public_path__ + "static/media/upvote-dark.e5670a12.svg";